import { render } from "./inventoryPeriod.vue?vue&type=template&id=f1142cbe&scoped=true"
import script from "./inventoryPeriod.vue?vue&type=script&lang=js"
export * from "./inventoryPeriod.vue?vue&type=script&lang=js"

import "./inventoryPeriod.vue?vue&type=style&index=0&id=f1142cbe&scoped=true&lang=scss"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1142cbe"]])

export default __exports__